import {
    EditGuesser,
    InputGuesser, 
  } from "@api-platform/admin";
  import {      
    SelectArrayInput ,
    ReferenceArrayInput
} from 'react-admin';

export const CategoryEdit = props => (
    <EditGuesser {...props} title="Editar Categoría">
        <InputGuesser source={"name"} label="Nombre"/>
        <InputGuesser source={"priority"} label="Orden"/>
        <ReferenceArrayInput label="Productos" reference="products" source="products">
            <SelectArrayInput optionText="name" />            
        </ReferenceArrayInput>
    </EditGuesser>
);

/*
<InputGuesser source={"categories"} />
 <InputGuesser source={"imagesProds"} />
*/